const storageKey = (adminId) => `rc_header_planner_id_${adminId}`;

export const getStoredHeaderPlannerId = (adminId) => {
  if (typeof window === 'undefined' || !adminId) return '';
  return sessionStorage.getItem(storageKey(adminId)) || '';
};

export const setStoredHeaderPlannerId = (adminId, plannerId) => {
  if (!adminId) return;
  if (!plannerId || plannerId === 'all') {
    sessionStorage.removeItem(storageKey(adminId));
  } else {
    sessionStorage.setItem(storageKey(adminId), plannerId);
  }
};
